import moment from 'moment';
import React from 'react';
import 'react-day-picker/lib/style.css';
import { useSelector } from 'react-redux';
import '../../../assets/scss/daterangepicker.scss';

const YearMonthForm = ({ date, localeUtils, getMonth }) => {
    const searchParams = useSelector(state => state.analyze.searchParams);
    const fromYear = moment(searchParams.custom.from).year();
    const selectedYear = fromYear ? fromYear : moment().year();
    const months = localeUtils.getMonths();

    // let years =[];

    // useEffect(() => {
    //     const startYear = moment.utc().year() - 3;
    //     const endYear = moment.utc().year();
    //     let data = [];

    //     for (let i = endYear; i >= startYear; i--) {            // enable to show year dropdown values
    //         data.push(i);
    //     }

    //     years.push(data);
    // }, []);

    const handleChange = (e, name) => {
        getMonth(e.target.value, name)
    };

    return (
        <div className="DayPicker-Caption">
            <select className="month-dropdown" name="month" onChange={(e) => handleChange(e, 'month')} value={date.getMonth()}>
                {months.map((month, i) => (
                    <option key={month} value={i}>
                        {month}
                    </option>
                ))}
            </select>
            <span style={{ color: "#767676" }}><b>{selectedYear}</b></span>

            {/* <select className="year-dropdown" name="year" onChange={(e) => handleChange(e, 'year')} value={date.getFullYear()}>
                {years.map((year, i) => (
                    <option key={year} value={year}>                      // enable for year dropdown
                        {year}
                    </option>
                ))}
            </select> */}
        </div>
    );
}

export default YearMonthForm;